import React, { useState, useEffect, useCallback } from 'react';
import { useNotify } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import sraApi from 'helpers/apis/sra';
import { LoadingStyled } from 'components';
import Recommendations from './Recommendations';
import RecommendationInfo from './RecommendationInfo';
import { RecommendationsProvider } from '../context/recommendationsContext';
import { useSRA } from '../context/sraContext';

const useStyles = makeStyles(theme => ({
  workPlan: {
    padding: '30px 0 20px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  recommendationList: {
    marginRight: 30,
    width: 'calc(70% - 15px)',
    display: 'flex',
    flexDirection: 'column'
  },
  recommendationInfo: {
    width: 'calc(30% - 15px)',
    minWidth: 250
  }
}));

const WorkPlanPage = () => {
  const classes = useStyles();
  const notify = useNotify();
  const {
    state: { revisionId }
  } = useSRA();
  const [currentRecommendation, setCurrentRecommendation] = useState(null);
  const [workPlanInfo, setWorkPlanInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const getWorkplanInfo = useCallback(
    showLoading => {
      if (revisionId) {
        if (showLoading) setLoading(true);
        sraApi
          .getWorkplanInfo(revisionId)
          .then(res => {
            setWorkPlanInfo(res?.data);
          })
          .catch(err => {
            notify(err?.response?.data?.message || 'Something went wrong', 'error');
          })
          .finally(() => {
            if (showLoading) setLoading(false);
          });
      }
    },
    [notify, revisionId]
  );

  useEffect(() => {
    getWorkplanInfo(true);
  }, [getWorkplanInfo]);

  if (loading || !revisionId) return <LoadingStyled />;

  return (
    <RecommendationsProvider>
      <div className={classes.workPlan}>
        <div className={classes.recommendationList}>
          <Recommendations
            currentRecommendation={currentRecommendation}
            setCurrentRecommendation={setCurrentRecommendation}
            revisionId={revisionId}
            outstandingRecommendations={workPlanInfo?.outstanding_recommendations}
          />
        </div>
        <div className={classes.recommendationInfo}>
          <RecommendationInfo
            currentRecommendation={currentRecommendation}
            setCurrentRecommendation={setCurrentRecommendation}
            aboutVideo={workPlanInfo?.video_url}
            getWorkplanInfo={getWorkplanInfo}
          />
        </div>
      </div>
    </RecommendationsProvider>
  );
};

export default WorkPlanPage;
